/* eslint-disable */

/**
 * Amplitude Analytics Module
 * Handles user tracking and event logging with GDPR compliance
 */

/**
 * Initialize Amplitude with GDPR-compliant settings
 */
export function initAmplitude(debug = false) {
  amplitude.getInstance().init(GT.amplitudeApiToken, null, {
    includeUtm: false,
    includeReferrer: false,
    disableCookies: true,
    trackingOptions: {
      ip_address: false,
      city: false,
      country: false,
      region: false,
    },
  });
}

/**
 * Set Amplitude user properties
 */
export function setAmplitudeUser(debug = false) {
  if (!window.user || !window.user.id) {
    return;
  }

  const extractUrlParts = (url) => {
    try {
      const myUrl = new URL(url);
      return {
        base: myUrl.protocol + "//" + myUrl.hostname + myUrl.pathname.split("?")[0].split("&")[0].split("#")[0],
        path: myUrl.pathname.split("?")[0].split("&")[0].split("#")[0],
        domain: myUrl.hostname,
      };
    } catch (e) {
      return {
        base: null,
        path: null,
        domain: null,
      };
    }
  };

  let userClone = Object.assign({ team: {}, subscription: {} }, user);

  let gp_landing = extractUrlParts(userClone.settings.gp_landing);
  let gp_regsource = extractUrlParts(userClone.settings.gp_regsource);
  let gp_referrer = extractUrlParts(userClone.settings.gp_referrer);

  let analyticsUser = {
    id: userClone.id,
    locale: userClone.locale,
    email: userClone.email,
    registrationTime: userClone.registrationTime,
    loginMethod: userClone.loginMethod,

    settings: {
      country: userClone.settings.country,
      gp_landing: userClone.settings.gp_landing,
      gp_referrer: userClone.settings.gp_referrer,
      gp_regsource: userClone.settings.gp_regsource,
      gp_landing_base: gp_landing.base,
      gp_landing_path: gp_landing.path,
      gp_landing_domain: gp_landing.domain,

      gp_regsource_base: gp_regsource.base,
      gp_regsource_path: gp_regsource.path,
      gp_regsource_domain: gp_regsource.domain,

      gp_referrer_base: gp_referrer.base,
      gp_referrer_path: gp_referrer.path,
      gp_referrer_domain: gp_referrer.domain,

      gp_utm: userClone.settings.gp_utm,
      user_company: userClone.settings.user_company,
      user_industry: userClone.settings.user_industry,
      user_job_field: userClone.settings.user_job_field,
      user_tool_used_before: userClone.settings.user_tool_used_before,
      user_planning_use_for: userClone.settings.user_planning_use_for,
      user_interested_features: userClone.settings.user_interested_features,
      user_job_title: userClone.settings.user_job_title,
      user_team: userClone.settings.user_team,

      onboarding_is_finished: userClone.settings.onboarding_is_finished,
      user_scoring_percent: userClone.settings.user_scoring_percent,
      user_scoring_value: userClone.settings.user_scoring_value,
      ad_source: userClone.settings.ad_source,
    },

    team: {
      id: userClone.team.id,
      is_owner: userClone.team.is_owner,
      owner_email: userClone.team.owner_email,
      owner_id: userClone.team.owner_id,
      is_jira: userClone.team.is_jira,
    },

    subscription: {
      date_to: userClone.subscription.date_to,
      is_annual: userClone.subscription.is_annual,
      is_trial: userClone.subscription.is_trial,
      payment_plans_id: userClone.subscription.payment_plans_id,
      provider: userClone.subscription.provider,
      user_count: userClone.subscription.user_count,
    },

    sso: {
      enabled: userClone.sso?.enabled || false,
    },

    twoFa: {
      active: userClone.twoFa?.active || false,
    },

    affiliate: {
      key: userClone?.affiliate?.key,
      coupon: userClone?.affiliate?.coupon,
    },
  };

  amplitude.getInstance().setUserId(userClone.id);
  amplitude.getInstance().setUserProperties(analyticsUser);

  if (debug) {
    console.info('[Amplitude] User properties set');
  }
}

/**
 * Log event to Amplitude
 */
export function logAmplitudeEvent(eventName, eventData, debug = false) {
  amplitude.getInstance().logEvent(eventName, eventData);

  if (debug) {
    console.info(`[Amplitude] Event: ${eventName}`);
  }
}
